function Facebook() {
    return (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_80_435)">
                <path d="M28.3443 30.0001C29.2586 30.0001 30 29.2588 30 28.3444V1.65574C30 0.741211 29.2586 0 28.3443 0H1.65574C0.741094 0 0 0.741211 0 1.65574V28.3444C0 29.2588 0.741094 30.0001 1.65574 30.0001H28.3443Z" fill="#395185" />
                <path d="M20.6993 30.0001V18.3825H24.5989L25.1828 13.855H20.6993V10.9642C20.6993 9.65332 21.0634 8.76 22.9432 8.76L25.3407 8.75894V4.70953C24.9259 4.65433 23.5028 4.53105 21.8471 4.53105C18.3904 4.53105 16.0239 6.64101 16.0239 10.5159V13.855H12.1143V18.3825H16.0239V30.0001H20.6993Z" fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_80_435">
                    <rect width="30" height="30" fill="white" />
                </clipPath>
            </defs>
        </svg>

    );
}

export default Facebook